<template>
    <div>
        <section class="thanks_wrp">
            <div class="page-container">
                <h1 class="omnes fw-semibold eyebrow-page">
                    <span class="omnes">Thank you for submitting</span>
                </h1>

                <div class="return-button">
                    <router-link to="/">Return home</router-link>
                </div>
            </div>
        </section>

        <div class="blue-line"></div>
    </div>
</template>

<script>
import DataList from '../models/dataList';
import headers from '../models/headers';
import cards from '../components/Cards';
import { validationAdress } from '../helpers/validationAdress';
import { mapState, mapGetters, mapActions } from 'vuex';
const thankYouTypes = { Usual: 1, CopayCards: 2 };

export default {
    components: {
        'irsh-cards': cards,
    },
    computed: {
        ...mapGetters(['headerClasses']),
    },
    methods: {
        ...mapActions(['setHeaderClasses']),
    },
    metaInfo: headers.thankYouPage(),
    data() {
        return {
            cards: DataList.thankYouPage().cards,
            address: null,
            hasValidAddress: false,
            wrapperClass: '',
            thankYouType: thankYouTypes.Usual,
        };
    },
    computed: {
        isUsualInfoContent() {
            return this.thankYouType === thankYouTypes.Usual;
        },
    },
    mounted() {
        const copayCardsSelected = sessionStorage.getItem('copayCardsSelected');
        console.log(copayCardsSelected);
        const state = sessionStorage.getItem('state');
        if (copayCardsSelected != null) {
            this.thankYouType = thankYouTypes.CopayCards;
            sessionStorage.removeItem('copayCardsSelected');
        } else if (state != null) {
            this.address = new validationAdress(state).validationAdressFunc();
            this.hasValidAddress = this.address != null;
            sessionStorage.removeItem('state');
            this.setHeaderClasses('big');
            this.wrapperClass = 'big';
        }
    },
};
</script>
